import UserPDPAReportRoute from './UserPDPAReportRoute';

export default UserPDPAReportRoute;
